import { createStore, combineReducers } from 'redux'
import sessionData from '../session/redux'
import msgData from '../msg/redux'
import userData from '../user/redux'
import groupData from '../group/redux'

const rootReducer = combineReducers({
    sessionData,
    msgData,
    userData,
    groupData
})

export function configureStore(initialState) {
    const store = createStore(rootReducer, initialState)

    // if (module.hot) {
    //   // Enable Webpack hot module replacement for reducers
    //   module.hot.accept('./redux', () => {
    //     const nextReducer = require('./redux').default
    //     store.replaceReducer(nextReducer)
    //   })
    // }

    return store
}


// WEBPACK FOOTER //
// ./src/utils/configureStore.js